<template>
  <div id="app">
    <Header></Header>
    <div class="main-container">
      <img class="header-bg" src="../assets/img/banner7.jpg" alt="" />
      <div class="articleList-container">
        <div class="articleList-content">
          <div class="library-list">
            <a
              class="library-item"
              :href="'blxq.html?id=' + i.id"
              v-for="i in cardList"
              :key="i.id"
            >
              <div class="green-">
                <img src="../assets/img/triangle.png" alt="">
              </div>
              <div class="library-image">
                <el-image lazy :src="i.img" fit="cover">
                  <div slot="placeholder" class="image-slot">
                    <img
                      src="data:image/png;base64,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"
                    />
                  </div>
                </el-image>
              </div>
              <div class="library-info">
                <div class="library-title">{{ i.name }}</div>
                <div class="tag">{{ i.address }}</div>
                <div class="desc">
                  {{ i.summary }}
                </div>
              </div>
            </a>
          </div>
          <div
            style="margin: 24px 0 40px; display: flex; justify-content: center"
          >
            <Pagination
              :totalpage="totalpage"
              :pagesize="12"
              @pageChange="pageChange"
            ></Pagination>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import Pagination from "../components/pagination.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Pagination,
  },
  data: () => {
    return {
      totalpage: 1,
      currentpage: 1,

      cardType: "0", //0 农技文章
      cardList: [
        {
          title: "",
          desc: "",
          author: "",
          time: "",
          clickViews: 10,
          imgUrl: "",
        },
      ],
    };
  },
  beforeMount() {
    function getUrlString() {
      var urlStr = window.location.search; //?sex=man&age=20
      console.log(urlStr);
      if (urlStr != null && urlStr.toString().length > 1) {
        var myUrlStr = urlStr.substr(1); //sex=man&age=20
        var array1 = myUrlStr.split("&"); //["sex=man"],["age=20"]
        var getString = {};
        for (var i = 0; i < array1.length; i++) {
          getString[array1[i].split("=")[0]] = array1[i].split("=")[1]; //["sex","man"]["age","20"]
        }
        return getString;
      } else {
        console.log("无参数");
      }
    }
    var gus = new getUrlString();
    console.log(gus);
    this.$axios
      .get(`catTribe/findCatTribeList?pageNum=1&pageSize=12`)
      .then((data) => {
        data = data.data;
        this.cardList = data.information.list;
        this.totalpage = data.information.total;
      });
  },
  methods: {
    pageChange(n) {
      console.log(n);
      this.$axios
        .get(`catTribe/findCatTribeList?pageNum=${n}&pageSize=12`)
        .then((data) => {
          data = data.data;
          this.cardList = data.information.list;
          this.totalpage = data.information.total;
        });
    },
  },
  mounted: () => {},
};
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}

.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}

.main-container {
  width: 100%;
  .header-bg {
    width: 100%;
    display: block;
  }
}
.crop-selector-container {
  width: 100%;
  background: #f5f5f5;
  padding: 40px 0 28px;
  .crop-selector {
    width: 1200px;
    margin: 0 auto;

    .crop-item {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: nowrap;
      margin-bottom: 18px;
      &:last-child {
        margin-bottom: 0;
      }
      .crop-group {
        font-size: 16px;
        width: 80px;
        color: #333;
        text-align: left;
        margin-right: 10px;
        line-height: 20px;
      }
      .crop-titles {
        font-size: 16px;
        width: 100px;
        flex-grow: 1;
        color: #999;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        line-height: 24px;
        a {
          border-right: 1px solid #999;
          color: #999;
          min-width: 60px;
          padding: 0 20px;
          line-height: 20px;
          height: 20px;
          margin-bottom: 12px;
          &:hover {
            color: #65b825;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }
}
.articleList-container {
  width: 100%;
  background: #fff;
  .articleList-content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 30px;

    .library-list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;

      .library-item {
        width: 280px;
        height: 350px;
        margin-right: 24px;
        margin-bottom: 24px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border: 1px solid transparent;
        background: #f5f5f5;
        &:hover {
          border-color: #65b825;
        }
        .green- {
          width: 100%;
          height: 50px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 4;
          img {
            width: 48px;
            // height: 76px;
            display: block;
          }
        }

        .library-image {
          width: 120px;
          height: 120px;
          z-index: 5;
          position: relative;
          border: 7px solid #fff;
          border-radius: 50%;
          overflow: hidden;
          .el-image {
            width: 106px;
            height: 106px;
          }
        }

        .library-info {
          width: 280px;
          height: 180px;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-direction: column;
          padding-top: 12px;

          .library-title {
            color: #333;
            font-size: 26px;
            margin-bottom: 6px;
            height: 35px;
            line-height: 35px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }
          .tag {
            font-size: 16px;
            // height: 24px;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #333;
            margin-bottom: 15px;
            padding-bottom: 10px;
            width: 100%;
            text-align: center;
            border-bottom: 1px dashed #e6e6e6;
          }
          .desc {
            font-size: 14px;
            width: 100%;
            line-height: 20px;
            height: 60px;
            overflow: hidden;
            color: #666;
            text-align: justify;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          .library-more {
            width: 176px;
            line-height: 46px;
            font-size: 18px;
            padding: 0 20px;
            border: 1px solid #fff;
            background: transparent;
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
              width: 20px;
              height: 12px;
            }
            span {
              color: #fff;
            }
            &:hover {
              background: #65b825;
              border-color: #65b825;
              span {
                color: #fff;
              }
            }
          }
        }
        &:hover {
          .library-info {
            opacity: 1;
          }
        }

        &:nth-of-type(4n + 0) {
          margin-right: 0;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  #app {
    margin-top: 91px;
  }
  .login_container {
		padding-left: 10px;
	}
	.headers {
		width: 100%;
		padding-left: 10px;
	}
	#app {
		overflow: hidden;
	}
	#app .headers .header-nav {
		display: none;
	}

  .crop-selector-container .crop-selector{
    width: 100%;
  }
  .crop-selector-container .crop-selector .crop-item .crop-group{
    margin-right: 0;
    font-size: 14px;
  }
  .crop-selector-container .crop-selector .crop-item .crop-titles{
    font-size: 14px;
    line-height: 20px;
    a{
      min-width: 80px;
      margin-bottom: 6px;
    }
  }
  .crop-selector-container{
    padding: 20px 10px 14px;
  }
  .likeList{
    display: none;
  }
  .articleList-container .articleList-content{
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    .articleList{
      margin-right: 0;
    }
  }
  .articleList-container .articleList-content .library-list{
    justify-content: space-around;
    .library-item{
      margin-right: 0;
      width: 100%;
      margin-bottom: 10px;
      .library-info{
        width: 100%;
        .library-title{
          font-size: 20px;
        }
        .tag{
          font-size: 16px;
        }
      }
    }
  }
}
</style>
